import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import "./menu.scss";
import "../../../../src/styles/hiddenProvisional.scss";

import logo from "../../../media/img/LogoDaromaHorizontal.png";
import BackArrow from "../backArrow/backArrow";
import LanguageSelector from "./languageSelector/LanguageSelector";

const Menu = ({ bannerHeight, customClass = "", isOffcanvasOpen, setIsOffcanvasOpen }) => {
  const { t } = useTranslation();
  const offcanvasRef = useRef(null);
  const offcanvasBodyRef = useRef(null);
  const location = useLocation();



  // useEffect(() => {
  //   const offcanvasElement = offcanvasRef.current;
  //   if (!offcanvasElement) return;

  //   const handleShow = () => {
  //     setIsOffcanvasOpen(true);
  //     document.body.classList.add("menu-open"); // ✅ Añadir clase al abrir
  //   };

  //   const handleHide = () => {
  //     setIsOffcanvasOpen(false);
  //     document.body.classList.remove("menu-open"); // ✅ Quitar clase al cerrar
  //   };

  //   offcanvasElement.addEventListener("shown.bs.offcanvas", handleShow);
  //   offcanvasElement.addEventListener("hidden.bs.offcanvas", handleHide);

  //   return () => {
  //     offcanvasElement.removeEventListener("shown.bs.offcanvas", handleShow);
  //     offcanvasElement.removeEventListener("hidden.bs.offcanvas", handleHide);
  //   };
  // }, []);

  useEffect(() => {
    const offcanvasElement = offcanvasRef.current;
    if (!offcanvasElement) return;

    const handleShow = () => setIsOffcanvasOpen && setIsOffcanvasOpen(true);
    const handleHide = () => setIsOffcanvasOpen && setIsOffcanvasOpen(false);

    offcanvasElement.addEventListener("shown.bs.offcanvas", handleShow);
    offcanvasElement.addEventListener("hidden.bs.offcanvas", handleHide);

    return () => {
      offcanvasElement.removeEventListener("shown.bs.offcanvas", handleShow);
      offcanvasElement.removeEventListener("hidden.bs.offcanvas", handleHide);
    };
  }, [setIsOffcanvasOpen]);




  const isActive = (path) => location.pathname === path;

  return (
    <>
      {/* <div className={`overlay ${isOffcanvasOpen ? "active" : ""}`}></div> */}

      <nav className={`navbar navbar-expand-lg fixed-top ${customClass}`}>
        <div className="container-fluid d-flex justify-content-between align-items-center w-100">
          <div className="logo">
            {location.pathname.startsWith("/case-study/") || location.pathname === "/faq" ? (
              <BackArrow />
            ) : (
              <img src={logo} alt="Logo" />
            )}
          </div>

          <button
            className="navbar-toggler d-lg-none"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#navbarContent"
            aria-controls="navbarContent"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="offcanvas offcanvas-top" id="navbarContent" ref={offcanvasRef} >
            <div className="offcanvas-header">
              <h5 className="offcanvas-title">daromainnovations</h5>
              <button
                type="button"
                className="btn-close text-reset custom-close-btn"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>
            <div className="offcanvas-body" ref={offcanvasBodyRef}>
              <div className="navbar1 d-flex flex-column flex-lg-row align-items-lg-center w-100 justify-content-end">
                <div className="navbar-nav d-flex flex-column flex-lg-row align-items-lg-center gap-3">

                  <LanguageSelector />
                  <a className={`nav-link ${isActive("/") ? "active" : ""}`} href="/">{t("navbar.home")}</a>
                  <a className={`nav-link ${isActive("/AboutUsPage") ? "active" : ""}`} href="/AboutUsPage">{t("navbar.about")}</a>
                  <a className={`nav-link ${isActive("/productos/products") ? "active" : ""}`} href="/productos/products">{t("navbar.products")}</a>
                  <a className={`nav-link ${isActive("/productos/services") ? "active" : ""}`} href="/productos/services">{t("navbar.services")}</a>
                  <a className={`nav-link ${isActive("/I+D+i") ? "active" : "I+D+i"}`} href="/I+D+i">{t("navbar.idi")}</a>
                  <a className={`nav-link ${isActive("/Contacto") ? "active" : ""}`} href="/Contacto">{t("navbar.contact")}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Menu;